import index from './index.vue';
import { SubFormData, ResData } from './all.type';

export default index;
export {
    SubFormData,
    ResData
};